import React from 'react';
import { Routes, Route } from 'react-router-dom';
import ProtectedRoute from 'src/routes/ProtectedRoute';
import PageNotFound from 'src/shared/components/page-not-found/PageNotFound';
import { getHabitatInsightsRoutesAvailability } from 'src/routes/state/routesSelector';
import { useAppSelector } from 'src/store';
import { IndividualRouteSetting, HabitatInsightViews } from 'src/routes/routesConfig';
import { Resources } from 'src/shared/types';
import { HabitatInsightsDetails } from './views/habitat-insights-details/HabitatInsightsDetails';
import AddSiteToPlatform from './views/add-site-to-platform/AddSiteToPlatform';

export const habitatInsightsRouteSettings: { [key in HabitatInsightViews]: IndividualRouteSetting } = {
    habitatInsightsUpload: {
        name: 'Habitat Insights Upload',
        path: '/habitat-insights-upload',
        handler: <HabitatInsightsDetails />,
        resource: Resources.HABITAT_INSIGHTS_UPLOAD,
    },
    habitatInsightsAddSite: {
        name: 'Add Site to Platform',
        path: '/add-site-to-platform',
        handler: <AddSiteToPlatform />,
        resource: Resources.HABITAT_INSIGHTS_UPLOAD,
    },
};

const HabitatInsights = () => {
    const routesConfig = useAppSelector(getHabitatInsightsRoutesAvailability);
    if (!routesConfig) {
        return null;
    }

    return (
        <Routes>
            {Object.keys(routesConfig).map(routeKey => {
                const isAvailable = routesConfig[routeKey as HabitatInsightViews];

                const routeSetting = habitatInsightsRouteSettings[routeKey as HabitatInsightViews];
                return (
                    <Route
                        path={routeSetting.path}
                        element={
                            <ProtectedRoute isAllowed={isAvailable} redirectPath={'/projects'} routeSetting={routeSetting}>
                                {routeSetting.handler}
                            </ProtectedRoute>
                        }
                        key={routeSetting.name}
                    />
                );
            })}
            <Route path='/*' element={<PageNotFound />} />
        </Routes>
    );
};
export default HabitatInsights;
